import { render, staticRenderFns } from "./AssignComponent.vue?vue&type=template&id=3a550696&scoped=true&"
import script from "./AssignComponent.vue?vue&type=script&lang=js&"
export * from "./AssignComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssignComponent.vue?vue&type=style&index=0&id=3a550696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a550696",
  null
  
)

export default component.exports